import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=5f2bc286&scoped=true&"
import script from "./Status.vue?vue&type=script&lang=ts&"
export * from "./Status.vue?vue&type=script&lang=ts&"
import style0 from "./Status.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Status.vue?vue&type=style&index=1&id=5f2bc286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2bc286",
  null
  
)

export default component.exports